import { rest } from 'msw'
import { QUERY_KEYS } from 'services/constant'

export const lojaNovoPedidoLojaMockHandlers = {
  post: () =>
    rest.post(`*/${QUERY_KEYS.LOJA.MEU_ENDERECO}`, async (_, res, ctx) => {
      return await res(ctx.status(200))
    }),
}
